import { render, staticRenderFns } from "./AcademySidemenuLayout.vue?vue&type=template&id=059daccf&scoped=true&lang=pug&"
import script from "./AcademySidemenuLayout.vue?vue&type=script&lang=ts&"
export * from "./AcademySidemenuLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059daccf",
  null
  
)

export default component.exports